import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import infoList from '@/mixins/infoList';
import { addRiskOne, getRiskList, riskList } from '@/api/risk';
export default {
  name: 'Risk',
  mixins: [infoList],
  data: function data() {
    return {
      riskChannel: '',
      riskChannelInt: null,
      riskChannelList: {},
      riskChannelItemList: [],
      Sing: '',
      addChannelDialogVisible: false,
      addRiskOne: {
        ID: '',
        Secret: '',
        ApiHost: '',
        Name: '',
        ReMark: '',
        Sign: ''
      }
    };
  },
  created: function created() {
    this.getRiskChannel();
  },
  methods: {
    getRiskChannel: function getRiskChannel() {
      var _this = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, key, _t, _t2;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 1;
              return getRiskList();
            case 1:
              res = _context.sent;
              if (!(res.code === 0)) {
                _context.next = 3;
                break;
              }
              _this.riskChannelList = res.data;
              _t = regeneratorRuntime.keys(res.data);
            case 2:
              if ((_t2 = _t()).done) {
                _context.next = 3;
                break;
              }
              key = _t2.value;
              _this.riskChannel = res.data[key];
              _this.riskChannelInt = _this.searchOption(res.data, res.data[key]);
              return _context.abrupt("continue", 3);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    onSubmit: function onSubmit() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 1;
              return riskList({
                ChannelId: parseInt(_this2.riskChannelInt)
              });
            case 1:
              res = _context2.sent;
              if (res.code === 0) {
                _this2.riskChannelItemList = res.data.list;
              }
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    addRiskChannel: function addRiskChannel() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(_this3.Sing === 'FORTER')) {
                _context3.next = 2;
                break;
              }
              _this3.addRiskOne.Sign = _this3.Sing;
              _context3.next = 1;
              return addRiskOne(_this3.addRiskOne);
            case 1:
              res = _context3.sent;
              if (res.code === 0) {
                _this3.$message.success(res.msg);
              }
            case 2:
              _this3.addChannelDialogVisible = false;
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    openAddRiskChannelDialog: function openAddRiskChannelDialog() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this4.addChannelDialogVisible = true;
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    closeAddRiskChannelDialog: function closeAddRiskChannelDialog() {
      this.addRiskOne.Name = '';
      this.addRiskOne.ApiHost = '';
      this.addRiskOne.Secret = '';
      this.addRiskOne.ID = '';
      this.addRiskOne.ReMark = '';
      this.addRiskOne.Sign = '';
    }
  }
};